// extracted by mini-css-extract-plugin
export default {"News":"News_News__-cWO9"};